const steps = [
  {
    icon: '🪪',
    title: 'Speakers get real names',
    description:
      'Voice recognition learned across your meetings turns “Speaker 2” into “Priya” — you confirm who’s who, adjust the speaker count if it guessed wrong, and the app gets sharper every meeting. Real diarization, no bot required.',
  },
  {
    icon: '🗂️',
    title: 'A summary shaped like the meeting',
    description:
      'A 1:1 isn’t a standup isn’t a sales call. Pick the meeting’s category — or define your own with its own note style — and Claude writes the summary the way that kind of meeting deserves.',
  },
  {
    icon: '➡️',
    title: 'Next steps walk straight into Claude',
    description:
      'Every action item becomes a one-click handoff: claude.ai opens with a fully-briefed prompt — who asked, what was agreed, what good looks like. The conversation lives in your real Claude history, not trapped in our app.',
  },
  {
    icon: '📤',
    title: 'Notes land in your tools',
    description:
      'A post-meeting skill delivers the summary anywhere your MCP servers reach — Notion, Linear, Slack, Obsidian, Google Drive. Your servers, your accounts, your formats. No “integrations” page, no per-seat connector fees.',
  },
];

const AfterMeeting = () => {
  return (
    <section className="meetings" id="after">
      <div className="section-container">
        <p className="overline overline--center">AFTER THE MEETING</p>
        <h2 className="section-title">You hang up. The work keeps moving.</h2>
        <p className="section-subtitle">
          Most tools end with a summary in their inbox. Solidly Meet ends with named speakers, notes
          written your way, delivered to your tools — and the follow-up work already open in Claude.
        </p>

        <div className="after-grid">
          {steps.map((s, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon" aria-hidden="true">
                {s.icon}
              </div>
              <h3>{s.title}</h3>
              <p>{s.description}</p>
            </div>
          ))}
        </div>

        <div className="meetings-note mono">
          The meeting ends in your tools and your Claude — not in ours.
        </div>
      </div>
    </section>
  );
};

export default AfterMeeting;
